module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-dla-dzieci.b5cd842e.png";